export function getSlideId() {
  var id = window.tnsId;
  window.tnsId = !id ? 1 : id + 1;
  
  return 'tns' + window.tnsId;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getSlideId.js
// module id = 852
// module chunks = 2